import { AHIcon, AHText, Box } from "arkh";
import React from "react";
import { IntegrationAdminListItem } from "./components/IntegrationAdminListItem";
import { graphql, useFragment } from "react-relay";

import { EmployeeScheduleUnAssignedTypesWarningText } from "../EmployeeSchedule/getEmployeeScheduleUnAssignedTypesWarningText";
import { IntegrationLogo, IntegrationLogoType } from "./components/Logos/Logos";
import { IntegrationAdminHRProviderListItem_Store$key } from "./__generated__/IntegrationAdminHRProviderListItem_Store.graphql";

export function IntegrationAdminHRProviderListItem(props: {
  isFirst: boolean;
  isLast: boolean;
  onPress(): void;
  store: IntegrationAdminHRProviderListItem_Store$key;
  disabled?: boolean;
  icon: IntegrationLogoType;
}) {
  const data = useFragment(
    graphql`
      fragment IntegrationAdminHRProviderListItem_Store on Store {
        employeeScheduleTypes {
          id
          assignedTeams {
            id
          }
        }
      }
    `,
    props.store
  );

  const unAssignedTypes = data.employeeScheduleTypes.filter(
    (type) => type.assignedTeams.length === 0
  );

  return (
    <IntegrationAdminListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      active
      onPress={props.onPress}
      disabled={props.disabled}
    >
      <Box
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          style={{
            flex: 1,
            flexDirection: "row",
            minHeight: 20,
            maxWidth: 70,
          }}
        >
          <IntegrationLogo type={props.icon} />
        </Box>

        {unAssignedTypes.length > 0 ? (
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              maxWidth: "45%",
              alignSelf: "flex-end",
              height: "100%",
            }}
          >
            <AHIcon type="issue" color="negative" spaceRight="xsmall" />
            <AHText type="detail" numberOfLines={2}>
              <EmployeeScheduleUnAssignedTypesWarningText
                unAssignedTypes={unAssignedTypes.length}
              />
            </AHText>
          </Box>
        ) : null}
      </Box>
    </IntegrationAdminListItem>
  );
}
